.milk-steamer-row {
  .milk-steamer-row-block {
    border-radius: 10px;
    .title {
      font-size: 15px;
      font-weight: 100;
    }
    .water, .pressure {
      .input {
        padding: 6px 15px 6px 0;
        border-radius: 10px;
        text-align: center;
        input {
          border: none;
          outline: none;
          box-shadow: none;
          font-size: 20px;
          font-weight: 100;
          text-align: center;
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/editor/milk-steamer/milk-steamer.scss